// Tüm metin girişlerini Türkçe büyük harfe çevirir (e-posta, şifre, sayı, tarih vb. hariç)
const SKIP_TYPES = new Set(["email", "password", "number", "date", "month", "time", "datetime-local", "file", "checkbox", "radio", "range", "color", "url", "tel", "hidden", "submit", "button"]);

export const trUpper = (s) => (s == null ? s : String(s).toLocaleUpperCase("tr-TR"));

export function installUppercaseInputs() {
  const handler = (e) => {
    const el = e.target;
    if (!el || el.dataset?.noUpper === "true" || el.closest?.("[data-no-upper]")) return;
    const tag = el.tagName;
    if (tag !== "INPUT" && tag !== "TEXTAREA") return;
    if (tag === "INPUT" && SKIP_TYPES.has((el.getAttribute("type") || "text").toLowerCase())) return;
    if (el.inputMode === "numeric" || el.inputMode === "decimal") return;
    const v = el.value;
    const up = trUpper(v);
    if (up === v) return;
    const s = el.selectionStart, en = el.selectionEnd;
    // React'in value tracker'ını atlayarak yaz: aksi halde onChange tetiklenmez ve state güncellenmez
    const proto = tag === "INPUT" ? window.HTMLInputElement.prototype : window.HTMLTextAreaElement.prototype;
    const setter = Object.getOwnPropertyDescriptor(proto, "value")?.set;
    if (setter) setter.call(el, up); else el.value = up;
    try { if (s != null) el.setSelectionRange(s, en); } catch (err) { console.debug("[uppercase] setSelectionRange desteklenmiyor:", el.type, err); }
  };
  // React kök dinleyicisinden önce çalışsın (capture, document seviyesi)
  document.addEventListener("input", handler, true);
  return () => document.removeEventListener("input", handler, true);
}
